document.addEventListener('DOMContentLoaded', (event) => {

    /*
    **====================================================================================
    **      MAIN FUNCTIONS
    **====================================================================================
    **/

    function prepend(newElem, elem) {
        elem.outerHTML = newElem + elem.outerHTML;
    }
    function append(newElem, elem) {
        elem.outerHTML = elem.outerHTML + newElem;
    }


    /*
    **====================================================================================
    **      CF7
    **====================================================================================
    **/

    //zmienne
    const mrfClass = "cf7-mod", mrfCheck = "is-check";
    //funkcje
    function resetCF7FormFields() {
        document.querySelectorAll(".jsCf7 input").forEach(function (elem, index) {
            if (["", "email", "tel", "text"].includes(elem.getAttribute("type"))) elem.value = "";
        });
        document.querySelectorAll(".jsCf7 textarea").forEach(function (elem, index) {
            elem.value = "";
        });
        document.querySelectorAll(".cf7-mod__checkbox").forEach(function (elem, index) {
            elem.classList.remove(mrfCheck);
            elem.nextSibling.checked = false;
        });
        document.querySelectorAll(".cf7-mod__radio").forEach(function (elem, index) {
            elem.classList.remove(mrfCheck);
            elem.nextSibling.checked = false;
        });
        for (const cf7Field of document.querySelectorAll(".jsCf7 .wpcf7-form-control")) {
            cf7Field.parentElement.classList.remove("wpcf7-form-control-wrap--active");
        }
    }
    //dodawanie odpowiednich elementów modyfikacji
    document.querySelectorAll(".jsCf7 .wpcf7-checkbox").forEach(function (elem, index) {
        elem.classList.add(mrfClass);
        elem.querySelectorAll("input").forEach(function (input, index) {
            if (input.getAttribute("type") == "checkbox") {
                let mrfSetCheck = "";
                if (input.checked) mrfSetCheck = " " + mrfCheck;
                let prependElement = input;
                if (input.parentNode.tagName == "LABEL") prependElement = input.parentNode;
                prepend("<span class='cf7-mod__checkbox" + mrfSetCheck + "'></span>", prependElement);
            }
        });
    });
    document.querySelectorAll(".jsCf7 .wpcf7-radio").forEach(function (elem, index) {
        elem.classList.add(mrfClass);
        elem.querySelectorAll("input").forEach(function (input, index) {
            if (input.getAttribute("type") == "radio") {
                let mrfSetCheck = "";
                if (input.checked) mrfSetCheck = " " + mrfCheck;
                let prependElement = input;
                if (input.parentNode.tagName == "LABEL") prependElement = input.parentNode;
                prepend("<span class='cf7-mod__radio" + mrfSetCheck + "'></span>", prependElement);
            }
        });
    });
    //zdarzenie click na elementach dodanych oraz obsługa klawisza enter
    //checkbox
    for (const elemCheckboxFieldWrap of document.querySelectorAll(".jsCf7 .cf7-mod .cf7-mod__checkbox")) {
        for (eventArray of ["click", "keypress"]) {
            elemCheckboxFieldWrap.addEventListener(eventArray, function (event) {
                if (event.type == "click" || event.key === "Enter") {
                    elemCheckboxFieldWrap.classList.toggle(mrfCheck);
                    let elemcCheckbox = elemCheckboxFieldWrap.nextSibling;
                    if (elemcCheckbox.tagName == "LABEL") elemcCheckbox = elemCheckboxFieldWrap.parentNode.querySelector("input");
                    if (elemCheckboxFieldWrap.classList.contains(mrfCheck)) {
                        elemcCheckbox.checked = true; elemcCheckbox.classList.add("tru");
                    }
                    else {
                        elemcCheckbox.checked = false; elemcCheckbox.classList.add("fals");
                    }
                }
            });
        }
    }
    //checkbox etykietka - wykrycie zmiany pola input
    for (const elemCheckboxField of document.querySelectorAll(".jsCf7 .cf7-mod.wpcf7-checkbox .wpcf7-list-item input")) {
        elemCheckboxField.addEventListener('change', function (event) {
            let checkModField = elemCheckboxField.parentElement.previousSibling;
            if (checkModField.classList.contains("cf7-mod__checkbox")) {
                if (elemCheckboxField.checked) checkModField.classList.add(mrfCheck);
                else checkModField.classList.remove(mrfCheck);
            }
        });
    }
    //radio
    for (const elemRadioFieldWrap of document.querySelectorAll(".jsCf7 .cf7-mod .cf7-mod__radio")) {
        elemRadioFieldWrap.addEventListener('click', function (event) {
            let parentMrfMod = elemRadioFieldWrap.parentElement.parentElement;
            if (parentMrfMod.classList.contains("cf7-mod")) {
                for (const elemcRadios of parentMrfMod.querySelectorAll(".cf7-mod__radio")) {
                    elemcRadios.classList.remove(mrfCheck);
                }
            }
            elemRadioFieldWrap.classList.toggle(mrfCheck);
            let elemcRadio = elemRadioFieldWrap.nextSibling;
            if (elemcRadio.tagName == "LABEL") elemcRadio = elemRadioFieldWrap.parentNode.querySelector("input");
            if (elemRadioFieldWrap.classList.contains(mrfCheck)) { elemcRadio.checked = true; elemcRadio.classList.add("tru"); }
            else {
                elemcRadio.checked = false; elemcRadio.classList.add("fals");
            }
        });
    }
    //radio etykietka - wykrycie zmiany pola input
    for (const elemRadioField of document.querySelectorAll(".jsCf7 .cf7-mod.wpcf7-radio .wpcf7-list-item input")) {
        elemRadioField.addEventListener('change', function (event) {
            //usunięcie wszystkich zaznaczeń
            let parentMrfMod = elemRadioField.parentElement.parentElement.parentElement;
            if (parentMrfMod.classList.contains("cf7-mod")) {
                for (const elemRadios of parentMrfMod.querySelectorAll(".cf7-mod__radio")) {
                    elemRadios.classList.remove(mrfCheck);
                }
            }
            let radioModField = elemRadioField.parentElement.previousSibling;
            if (radioModField.classList.contains("cf7-mod__radio")) {
                if (elemRadioField.checked) radioModField.classList.add(mrfCheck);
                else radioModField.classList.remove(mrfCheck);
            }
        });
    }
    //etykietki pól standardowych
    for (const cf7Field of document.querySelectorAll(".jsCf7 .wpcf7-form-control")) {
        let activeClass = "wpcf7-form-control-wrap--active";
        let elemParent = cf7Field.parentElement;
        cf7Field.addEventListener('input', function (event) {
            if (cf7Field.tagName == "INPUT" || cf7Field.tagName == "TEXTAREA") {
                if (cf7Field.value == "") elemParent.classList.remove(activeClass);
                else {
                    if (!elemParent.classList.contains(activeClass)) {
                        elemParent.classList.add(activeClass);
                    }
                }
            }
        });
        if (cf7Field.value != "") {
            if (!elemParent.classList.contains(activeClass)) {
                elemParent.classList.add(activeClass);
            }
        }
        cf7Field.addEventListener('click', function (event) {
            if (cf7Field.tagName == "INPUT" || cf7Field.tagName == "TEXTAREA") {
                document.querySelectorAll(".jsCf7 .wpcf7-form-control-wrap").forEach(function (elemControlWrap, index) {
                    let nextSibling = elemControlWrap.nextElementSibling;
                    if (nextSibling && nextSibling.classList.contains("wpcf7-field-label")) {
                        let elemField = elemControlWrap.querySelector(".wpcf7-form-control");
                        if (elemField.value == "" && (elemField.tagName == "INPUT" || elemField.tagName == "TEXTAREA")) {
                            elemControlWrap.classList.remove(activeClass);
                        }
                    }
                });
                if (!elemParent.classList.contains(activeClass)) {
                    elemParent.classList.add(activeClass);
                }
            }
        });
    }
    //symulacja clicka na submicie (przycisk obsługujący jest innym elementem, a właściwy submit jest ukryty)
    /*const iptcfSubmit = document.querySelector(".c-cf__row--submit .ipt-btn--submit");
    if (iptcfSubmit != null) {
        iptcfSubmit.addEventListener("click", function(event) {
            iptcfSubmit.parentNode.querySelector(".wpcf7-submit").click();
        });
    }*/
    //symulacja clicka na resecie (j/w)
    const iptcfReset = document.querySelector(".jsCf7BtnReset");
    if (iptcfReset != null) {
        for (eventArray of ["click", "keypress"]) {
            iptcfReset.addEventListener(eventArray, function (event) {
                if (event.type == "click" || event.key === "Enter") {
                    resetCF7FormFields();
                }
            });
        }
    }
    document.addEventListener('wpcf7mailsent', function (event) {
        resetCF7FormFields();
    }, false);

    //wybór pliku
    const iptcfFile = document.querySelector(".c-cf7__row--file .c-cf7__file-btn");
    if (iptcfFile != null) {
        iptcfFile.addEventListener("click", function (event) {
            iptcfFile.parentNode.parentNode.parentNode.querySelector(".c-cf7__file-field").click();
        });
    }
    const iptcfFileField = document.querySelector(".c-cf7__file-field");
    if (iptcfFileField != null) {
        iptcfFileField.addEventListener("change", function (event) {
            let thisValArray = iptcfFileField.value.split("\\");
            document.querySelector(".c-cf7__row--file .c-cf7__file-name").innerHTML = thisValArray[thisValArray.length - 1];
        });
    }

    //rodo - more
    const iptRodoElement = document.querySelector(".jsRodoElem .wpcf7-list-item-label");
    if (iptRodoElement != null) {
        let iptRodoElementVal = iptRodoElement.innerHTML;
        iptRodoElementVal = iptRodoElementVal.replace("%ws%", '<span class="cf7-rodo-more-btn jsRodoMoreBtn" tabindex="0">Więcej &raquo;</span><span class="cf7-rodo-hide-text jsRodoMoreText">');
        iptRodoElementVal = iptRodoElementVal.replace("%we%", '</span>');
        iptRodoElement.innerHTML = iptRodoElementVal;

        const iptRodoMoreBtn = iptRodoElement.querySelector(".jsRodoMoreBtn");
        if (iptRodoMoreBtn != null) {
            for (eventArray of ["click", "keypress"]) {
                iptRodoMoreBtn.addEventListener(eventArray, function (event) {
                    if (event.type == "click" || event.key === "Enter") {
                        iptRodoMoreBtn.remove();
                        iptRodoElement.querySelector(".jsRodoMoreText").classList.add("cf7-rodo-hide-text--is-show");
                    }
                });
            }
        }
    }


    /*
    **====================================================================================
    **      IN VIEW
    **====================================================================================
    **/

    let iptInViewElements = [];
    let iptInViewElementsCounter = 0;
    let iptInViewEventTimeout;
    let iptInViewRegAttr = '[reg-in-view="1"]';
    let iptInViewSetAttr = "set-xyz";
    let iptInViewClass = "is-in-view";
    let iptInViewOffset = -150;

    /*
        Zbieranie zarejestrowanych elementów do tablicy
    */

    document.querySelectorAll(iptInViewRegAttr).forEach(function (ivElem, index) {
        ivElem.isInView = false;
        iptInViewElements.push(ivElem);
    });

    if (screen.width <= 360) iptInViewOffset = -30;

    /*
        Opcje mechanizmu IntersectionObserver
    */

    const iptInViewObserverOptions = {
        root: null, // Obserwujemy względem całego widocznego obszaru przeglądarki
        rootMargin: '0px 0px ' + iptInViewOffset + 'px 0px', // marginesy wokół obszaru
        //threshold: 0.5 // Element będzie uznany za widoczny, gdy 50% będzie w polu widzenia
    };

    /*
        Tworzymy mechanizm IntersectionObserver
    */

    const iptInViewObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Jeśli element jest widoczny w polu widzenia, ustawiamy zmienną isInView na true
                entry.target.isInView = true;
            }
        });
    }, iptInViewObserverOptions);

    /*
        Ustawiamy mechanizm IntersectionObserver dla każdego elementu zarejestrowanego
    */
    iptInViewElements.forEach(target => {
        iptInViewObserver.observe(target);
    });

    /*
        Funkcja przygotowująca, która sprawdza, czy wszystkie elementy zostały już zanimowane. Dodany jest też timeout, który wspomaga działanie
    */

    function iptInViewPrepare(onReload) {
        if (!iptInViewEventTimeout && iptInViewElementsCounter < iptInViewElements.length) {
            iptInViewEventTimeout = setTimeout(function () {
                iptInViewEventTimeout = null;
                iptInViewCheck(onReload);
            }, 300);
        }
    }
    function iptInViewCheck(onReload) {
        iptInViewElements.forEach(function (ivElem, index) {
            if (!ivElem.classList.contains(iptInViewClass)) {
                let condIsInView = false;
                if (onReload == true) {
                    /*
                        Warunkowe odkrycie elementu jeżeli znajduje się on w polu widoku (wyznaczonym przez ekran), jednak niedaleko poza wytyczonymi w observerze granicami przez parametr rootMargin i tylko w przypadku gdy funkcja iptInViewCheck wykonuje się na skutek załadowania się strony (onReload == true) i tylko wtedy gdy strona jest przeskrolowana do samej góry (window.scrollY = 0).
                        Na przykład gdy margines dolny w rootMargin to -150px, a górna krawędź elementu po załadowaniu się strony znajduje się o 106px powyżej dolnej krawędzi przeglądarki, to generalnie element jest poza widokiem w observerze, ale na ekranie widzimy pustą przestrzeń.

                        Margines różnicy został tu ustalony na 60px, czyli jeżeli górna krawędź elementu znajduje się nie dalej niż 150 - 60px powyżej dolnej krawędzi ekranu, czyli o max 60px poniżej linii baseline, którą wyznacza nam rootMargin, to wtedy ustawiamy zmienną condIsInView na true i element jest warunkowo odkryty.
                    */
                    let ivElemOffsetFromTop = ivElem.getBoundingClientRect().top + window.scrollY;
                    if (((ivElemOffsetFromTop - 60) < (window.innerHeight + iptInViewOffset)) && window.scrollY == 0) condIsInView = true;
                }
                if (ivElem.isInView == true || condIsInView == true) {
                    iptInViewElementsCounter++;
                    if (!ivElem.classList.contains(iptInViewClass)) {
                        ivElem.classList.add(iptInViewClass);
                        let xyz = ivElem.getAttribute(iptInViewSetAttr);
                        if (xyz) {
                            ivElem.classList.add(xyz);
                            ivElem.removeAttribute(iptInViewSetAttr);
                        }
                    }
                }
            }
        });
    }

    let isInViewTicking = false;
    for (event of ["resize", "orientationchange"]) {
        window.addEventListener(event, function () {
            if (!isInViewTicking) {
                iptInViewPrepare(false);
                isInViewTicking = true;
            }
        });
    }
    for (event of ["scroll"]) {
        window.addEventListener(event, function () {
            iptInViewPrepare(false);
        });
    }

    iptInViewPrepare(true);


    /*
    **====================================================================================
    **      SCROLL TO ELEMENT
    **====================================================================================
    **/
    function getElementY(query) {
        if (document.querySelector(query)) return window.scrollY + document.querySelector(query).getBoundingClientRect().top;
        else return "";
    }

    function doScrolling(element, duration) {
        let startingY = window.pageYOffset;
        const elementY = getElementY(element);
        // If element is close to page's bottom then window will scroll only to some position above the element.
        let targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY;
        let diff = targetY - startingY;
        // Easing function: easeInOutCubic
        // From: https://gist.github.com/gre/1650294
        const easing = function (t) {
            return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        }
        let start;

        if (!diff) return;

        // Bootstrap our animation - it will get called right before next frame shall be rendered.
        window.requestAnimationFrame(function step(timestamp) {
            if (!start) start = timestamp;
            // Elapsed miliseconds since start of scrolling.
            let time = timestamp - start;
            // Get percent of completion in range [0, 1].
            let percent = Math.min(time / duration, 1);
            // Apply the easing.
            // It can cause bad-looking slow frames in browser performance tool, so be careful.
            percent = easing(percent);

            window.scrollTo(0, startingY + diff * percent);

            // Proceed with animation as long as we wanted it to.
            if (time < duration) {
                window.requestAnimationFrame(step);
            }
        })
    }

    for (const elemc of document.querySelectorAll(".jsScrollLink")) {
        elemc.addEventListener('click', function (event) {
            let hrefID = elemc.getAttribute("href");
            doScrolling(hrefID, 1000);
        });
    }
    for (const elemc of document.querySelectorAll(".jsScrollLink a")) {
        elemc.addEventListener('click', function (event) {
            let hrefID = elemc.getAttribute("href");
            doScrolling(hrefID, 1000);
        });
    }
    if (window.location.hash != "") {
        doScrolling(window.location.hash, 1000);
    }


    /*
    **====================================================================================
    **		HEADER EVENTS
    **====================================================================================
    **/

    let elemHeader = document.querySelector(".jsSiteHeader");
    let elemHeaderMainContainer = "";
    let elemHeaderMainInner = "";
    let elemHeaderNavContainer = "";
    let elemHeaderNavInner = "";
    let isHome = false;
    let offsetToSticky = 0;

    if (elemHeader) {
        //menu po prawej stronie logotypu
        elemHeaderMainContainer = elemHeader.querySelector(".jsSiteHeaderMainContainer");
        if (elemHeaderMainContainer) elemHeaderMainInner = elemHeaderMainContainer.querySelector(".jsSiteHeaderMainInner");

        //menu pod logotypem
        //elemHeaderNavContainer = elemHeader.querySelector(".jsSiteHeaderNavContainer");
        //if (elemHeaderNavContainer) elemHeaderNavInner = elemHeaderNavContainer.querySelector(".jsSiteHeaderNavInner");

        if (document.body.classList.contains("home")) isHome = true;

        //elemHeaderStickyBase.setAttribute("style", "height: " + elemHeaderMainContainer.offsetHeight + "px");
        //offsetToSticky = elemHeaderTopPanel.offsetHeight;

        //menu po prawej stronie logotypu
        offsetToSticky = elemHeaderMainInner.getBoundingClientRect().top + window.scrollY;

        //menu pod logotypem
        //offsetToSticky = elemHeaderNavContainer.getBoundingClientRect().top + window.scrollY;
    }

    function headerScrollEvent(scrollPos) {
        if (elemHeader) {
            if (window.screen.width > 991) {
                if (scrollPos > offsetToSticky) {
                    elemHeader.classList.add("is-sticky");
                }
                else {
                    elemHeader.classList.remove("is-sticky");
                }
            }
        }
    }

    let isHeaderTicking = false;
    for (eventArray of ["resize", "orientationchange"]) {
        window.addEventListener(eventArray, function () {
            if (!isHeaderTicking) {
                if (elemHeader) offsetToSticky = elemHeaderMainInner.getBoundingClientRect().top + window.scrollY;
                //if (elemHeader) offsetToSticky = elemHeaderNavContainer.getBoundingClientRect().top + window.scrollY;
                isHeaderTicking = true;
            }
        }, { passive: true });
    }

    if (elemHeader) headerScrollEvent(window.scrollY);


    /*
    **====================================================================================
    **      HEADER & SUB MENU FIX
    **====================================================================================
    **/

    function fixNaviMenu() {
        document.querySelectorAll(".jsHeaderNavi .sub-menu").forEach(function (elem, index) {
            let rect = elem.getBoundingClientRect();
            let posLeftAndWidth = rect.left + rect.width;
            if (posLeftAndWidth > window.innerWidth) elem.classList.add("sub-menu--pos-fix");
        });
    }
    fixNaviMenu();

    for (eventArray of ["resize", "scroll", "orientationchange"]) {
        window.addEventListener(eventArray, function () {
            fixNaviMenu();
        });
    }


    /*
    **====================================================================================
    **      HEADER & SEARCHER
    **====================================================================================
    **/

    const iptSearcher = document.querySelector(".jsHeaderSearcher");
    if (iptSearcher != null) {
        const iptSearcherFormWrap = document.querySelector(".jsSearcherForm");
        const iptSearcherBtn = iptSearcher.querySelector(".jsHeaderSearcherBtn");
        let iptSearcherBtnActiveClass = "is-active";
        let iptSearcherFormWrapShowClass = "is-show";
        if (iptSearcherBtn != null) {
            iptSearcherBtn.addEventListener("click", function (event) {
                iptSearcherBtn.classList.toggle(iptSearcherBtnActiveClass);
                iptSearcherFormWrap.classList.toggle(iptSearcherFormWrapShowClass);
            });
        }
        const iptSearcherFullBtnClose = document.querySelector(".jsSearcherFullCloseBtn");
        if (iptSearcherFullBtnClose != null) {
            iptSearcherFullBtnClose.addEventListener("click", function (event) {
                iptSearcherBtn.classList.remove(iptSearcherBtnActiveClass);
                iptSearcherFormWrap.classList.remove(iptSearcherFormWrapShowClass);
            });
        }
    }


    /*
    **====================================================================================
    **		SCROLL EVENTS
    **====================================================================================
    **/
    let scrollPosition = 0;
    let ticking = false;

    document.addEventListener('scroll', function (e) {
        scrollPosition = window.scrollY;

        if (!ticking) {
            window.requestAnimationFrame(function () {
                headerScrollEvent(scrollPosition);
                //timeLineScrollEvent(scrollPosition);
                ticking = false;
            });
            ticking = true;
        }
    });


    /*
**====================================================================================================
**      PARALLAXIFY
**====================================================================================================
**/
    let parallaxifyElemArray = [];

    function parallaxifyInit() {
        const parallaxifyTargets = document.querySelectorAll('.s-parallax');

        parallaxifyTargets.forEach(function (parallaxObj, index) {
            /*
                Tworzymy element containerParallax jeżeli jeszcze nie istnieje (w czasie zdarzenia resize ta funkcja będzie się wykonywała, ale element już będzie istniał)
            */
            let containerParallax = "";
            if (parallaxObj.querySelector(".s-parallax-container") == null) {
                containerParallax = document.createElement('div');
                containerParallax.classList.add("s-parallax-container");
                parallaxObj.appendChild(containerParallax);
            }
            else containerParallax = parallaxObj.querySelector(".s-parallax-container");

            const parallaxData = parallaxObj.querySelector(".s-parallax-data");
            let imgWidth = 0, imgHeight = 0, imgSpeed = 75;

            if (parallaxData) {
                imgRWDtype = "full";
                if (window.innerWidth <= 800 && window.innerWidth > 480) imgRWDtype = "medium";
                else if (window.innerWidth <= 480) imgRWDtype = "small";
                imgUrl = parallaxData.getAttribute("data-parallaxify-image-url-" + imgRWDtype);
                imgWidth = parallaxData.getAttribute("data-parallaxify-image-width-" + imgRWDtype);
                imgHeight = parallaxData.getAttribute("data-parallaxify-image-height-" + imgRWDtype);

                if (imgUrl == "") {
                    imgUrl = parallaxData.getAttribute("data-parallaxify-image-url-full");
                    imgWidth = parallaxData.getAttribute("data-parallaxify-image-width-full");
                    imgHeight = parallaxData.getAttribute("data-parallaxify-image-height-full");
                }

                imgSpeed = parallaxData.getAttribute("data-parallaxify-speed");
                if (imgUrl) {
                    //Tło ustawiamy dla obiektu parallaxObj lub containerParallax
                    //parallaxObj.style.backgroundImage = "url('" + imgUrl + "')";
                    containerParallax.style.backgroundImage = "url('" + imgUrl + "')";
                }
                //elem.querySelector(".elementor-widget-html").remove();
            }

            /*
                Wstawiamy do tablicy element parallax wraz z odpowiednimi parametrami, które będą wykorzystywane podczas scrollowania
            */
            parallaxifyElemArray.push({
                property: "background-position-y",
                speed: imgSpeed,
                imagesize: {
                    w: imgWidth,
                    h: imgHeight
                },
                isInView: false,
                container: parallaxObj,
                containerParallax: containerParallax
            });
        });

        /*
            Wstępne wyliczenia pozycji tła na osi Y
        */
        parallaxifyElemArray.forEach(function (parallaxObj, index) {
            let container = parallaxObj.container;
            let containerParallax = parallaxObj.containerParallax;
            if (container) {
                switch (parallaxObj.property) {
                    case "background-position-y":
                        if (!parallaxObj.speed) parallaxObj.speed = 75;

                        /*
                            Zmiana wprowadzona w lutym 2025:
                            Baseline był dotychczas przeliczany podczas każdego scrolla. Jeżeli kontener na starcie znajdował się powyżej baseline, to baseline był zmieniany i ustawiany tam, gdzie górna krawędź tego kontenera. To był błąd.
                            Baseline jest teraz ustalany tylko raz i zapisywany do zmiennej parallaxObj.baseline. Dodatkowo jest zaokrąglany.

                            Mało tego, gdy zdarzenie resize nie było zabezpieczone (kod na samym dole), to dochodziło nawet do nieoczekiwanej zmiany położenia linii baseline, ponieważ zmieniał się wtedy window.innerHeight. Ta sytuacja miała miejsce na telefonach gdy w czasie scrollu znikał pasek URL przeglądarki. Po zabezpieczeniu resize oraz przeniesieniu obliczenia baseline tutaj, problemy zniknęły
                        */
                        if (!parallaxObj.baseline) parallaxObj.baseline = 50;
                        parallaxObj.baseline = window.innerHeight - parallaxObj.baseline;
                        if ((container.getBoundingClientRect().top + window.scrollY) < parallaxObj.baseline) {
                            parallaxObj.baseline = Math.round(container.getBoundingClientRect().top + window.scrollY);
                        }

                        /*
                            Aby cokolwiek obliczyć, trzeba najpierw wiedzieć jaka jest zasada działania skryptu parallax, albowiem tło przesuwa się w kontenerze tylko wtedy, gdy kontener znajduje się w konkretnym obszarze. Obszar jest wyznaczany przez dwie wirtualne linie poziome. Pierwszą linią jest górna krawędź okna przeglądarki, drugą natomiast jedna z kluczowych zmiennych w skrypcie, czyli zmienna baseline. Jest to linia, która znajduje się kawałek powyżej dolnej krawędzi okna przeglądarki. Dlaczego drugą linią nie jest po prostu dolna krawędź przeglądarki? Ponieważ nie chcemy aby tło (w ledwo widocznym zza dolnej krawędzi okna kontenerze) już się przesuwało. Chcemy opóźnić nieco animację przesuwania, stąd właśnie zmienna baseline. Poza tym zmienna baseline odpowiada również za obliczenie wartości przesunięcia tła w kontenerze. Stanowi punkt odniesienia dla każdego kontenra.

                            A więc jeżeli chodzi o wyznaczony przez obie linie obszar, tło nie przesuwa się, gdy kontener jest poniżej linii baseline oraz gdy schowa się za górną krawędzią okna - inaczej mówiąc: tło w kontenerze przesuwa się dopóki, dopóty:
                            - górna krawędź kontenera znajduje się powyżej linii baseline
                            i
                            - dolna krawędź kontenera znajduje się poniżej górnej krawędzi okna

                            Tło na osi Y ma pozycję 0 w momencie, gdy górna krawędź kontenera styka się z górną krawędzą okna przeglądarki. Gdy górna krawędź kontenera zaczyna iść powyżej tej linii, pozycja Y tła zaczyna się robić dodatnia i tło nie pokrywa całego kontenera (patrząc na górną jego część) - ten "brak" jednak nie jest widoczny, ponieważ ma to miejsce poza ekranem (nad górną krawędzią okna przeglądarki). Pozycja tła na osi Y ma wartości ujemne, gdy kontener jest poniżej górnej krawędzi okna przeglądarki. Taka zasada działania pozwala wyeliminować nadmiarowe wymiary zdjęcia, zwłaszcza jeżeli chodzi o jego wysokość. Oczywiście można zrobić zdjęcie wysokie na 3000px i w ogóle nie liczyć startowego przesunięcia, ponieważ gdy zdjęcie ostylujemy na cover i position bottom, to będziemy go mieli wystarczająco w nadmiarze u góry by wykonać przesunięcie. Ale po co nam tak duże zdjęcie skoro jego części w ogóle nie zobaczymy?

                            Samo przesunięcie wykonuje się w odniesieniu do linii baseline. Zasada jest prosta - jeżeli górna krawędź kontenera znajduje się 100px powyżej linii baseline, to tło przesuwamy o 100px w dół (oś Y). Czyli o tyle, o ile kontener znajduje się nad linią baseline, o tyle przesuwamy tło w tym kontenerze w dół. W praktyce wygląda to jednak nieco inaczej, ponieważ gdyby to działało w ten sposób, to tło przesuwałoby się bardzo szybko, do tego stopnia, że byłoby jakby w pozycji fixed (widoczne by były jego nienaturalne skoki). I tu pojawia się zmienna speed, która obniża nam wartość przesunięcia względem odległości pomiędzy baseline, a górą krawędzią kontenera. Na przykład, gdy górna krawędź kontenera znajduje się 100px powyżej baseline, to przesunięcie tła wynosi zaledwie 2px, a nie 100px, co daje spokojny efekt płynności.

                            Głównym zadaniem tej części skryptu jest takie startowe przesunięcia tła w górę na osi Y, aby podczas scrollowania strony to przesunięcie na osi Y wynosiło 0 dokładnie w momencie, gdy kontener swoją górną krawędzią styka się z górną krawędzią okna przeglądarki. Należy oczywiście wziąć pod uwagę przelicznik speed. Jeżeli nie byłoby zmiennej speed, to startowe przesunięcie tła wynosiłoby aż tyle ile wynosi baseline [lub baseline + container.offsetHeight jeżeli korzystamy z opcji - linia 145] (jako wartość ujemna), co by dało efekt podobny do position fixed - zdjęcie zjeżdżałoby o tyle, o ile kontener wychodzi zza baseline (w stronę góry), czyli praktycznie byłoby cały czas przyklejone na górze. W tej sytuacji przesunięcie tła na osi Y będzie wynosiło 0 w momencie, gdy górna (lub dolna - linia 145) krawędź kontenera styknie się z górną krawędzią okna. Teoretycznie jest to przeliczenie prawidłowe, ale zdjęcie w tej sytuacji przesuwałoby się za szybko i musiałoby mieć bardzo dużą wysokość. Dlatego też speed zmniejsza tę prędkość, a co za tym idzie - redukuje wysokość zdjęcia.

                            Zasada jest taka: im mniejsza prędkość przesuwania, tym mniejsza wysokość zdjęcia. Im większa prędkość, tym więcej zdjęcia trzeba mieć w "naddatku". Podobny wpływ na wysokość zdjęcia ma linia baseline, ponieważ im jest ona wyżej, tym mniejsza wysokość zdjęcia jest potrzebna.

                            Linia baseline w wyjątkowej sytuacji może zmienić swoje położenie i stać się linią wyznaczającą górną krawędź kontenera względem górnej krawędzi okna przeglądarki, czyli być po prostu odległością kontenera (jego górnej krawędzi) od górnej krawędzi okna. Ma to miejsce, gdy kontener znajduje się u góry strony (sekcja hero, sekcja z tytułem podstrony) i wiadomo, że nigdy nie zjedzie on poniżej linii baseline. W związku z tym nie ma sensu obliczanie przesunięcia tła na osi Y względem pierwotnego położenia baseline, ponieważ wtedy zdjęcie miałoby zbyt wielką wysokość, a i tak całe nie zostałoby "pokazane".

                            Opcjonalnie:
                            Dla elementów znajdujących się na starcie poniżej baseline można w poniższym obliczeniu do zmiennej parallaxObj.initialBackPosY dodać jeszcze wysokość kontenera (container.offsetHeight), czyli parallaxObj.initialBackPosY = baseLine + container.offsetHeight;
                            Spowoduje to, że tło na osi Y będzie w pozycji zero, gdy z górną krawędzią okna przeglądarki spotka się nie górna, a dolna krawędź kontenera. Wtedy jednak "naddatek" zdjęcia będzie musiał być nieco większy.

                            Uwaga:
                            container.getBoundingClientRect().top może się różnić w momencie wczytywania strony od rzeczywistej odległości elementu od górnej krawędzi okna jeżeli pomiędzy nimi ładują się jakieś elementy i wysokość ich jest chwilowo wyższa. Tej wartości jednak używamy tylko do sprawdzania czy element jest poniżej baseline, a nie do obliczeń więc dla elementów znajdujących się sporo poniżej baseline nie powinno być problemu.
                        */

                        /*
                            Zmienna parallaxObj.initialBackPosY na początek jest odległością pomiędzy górną krawędzią kontenera, a górną krawędzią okna przeglądarki
                            Następnie sprawdzamy czy ta odległość jest większa niż pozycja linii baseline.
                            Jeżeli tak, to wtedy zmienna parallaxObj.initialBackPosY będzie stanowiła wartość baseline (lub baseline + wysokość kontenera - opcja z linii 145).
                            To jest wartość startowego przesunięcia tła na osi Y, jeszcze bez uwzględniania przelicznika speed, o czy była mowa kilka akapitów wyżej (linia 139)
                        */
                        parallaxObj.initialBackPosY = container.getBoundingClientRect().top + window.scrollY;
                        if (parallaxObj.initialBackPosY >= parallaxObj.baseline) parallaxObj.initialBackPosY = parallaxObj.baseline;

                        /*
                            Następnie zmienną parallaxObj.initialBackPosY będziemy odpowiednio pomniejszać za pomocą zmiennej speed.
                            Zmienna parallaxObj.speed to parametr - liczba od 1 do 100. Musimy ją następnie odpowiednio obrobić.
                            Samo speed = 100 - parallaxObj.speed nie wystarczy bo w praktyce na skali, to od 0 do około 85 przesuwanie było powolne, a szybciej zaczynało się powyżej 90. Dlatego jeszcze dzielimy przez 5 żeby szybsze prędkości zaczynały się wcześniej niż np. przy speed = 95
                        */
                        let speed = (100 - parallaxObj.speed) / 5;
                        if (speed < 0 || speed > 100) speed = 10;
                        else if (speed == 0) speed = 1;
                        parallaxObj.speed = speed; //zmienna zostaje zapisana do parallaxObj.speed żeby nie trzeba było jej co chwilę przeliczać
                        parallaxObj.initialBackPosY = Math.round(parallaxObj.initialBackPosY / speed); //pomniejszamy zmienną parallaxObj.initialBackPosY czyli dzielimy ją przez speed
                        if (parallaxObj.initialBackPosY > 0) parallaxObj.initialBackPosY = -1 * parallaxObj.initialBackPosY; //zmienna musi być ujemna

                        /*
                            Wiemy już jakie jest przesunięcie. Teraz trzeba obliczyć prawidłowe wymiary zdjęcia. Przy dobrze przygotowanym zdjęciu jego przesunięcie oraz "naddatek" do wysokości to będą te same liczby.

                            Przeliczenie prawidłowej wysokości zdjęcia (a precyzyjniej: wysokości tła w sekcji, która może się różnić od faktycznej wysokości zdjęcia), biorąc pod uwagę wyliczone jego przesunięcie (parallaxObj.initialBackPosY), a także szerokość kontenera i jego wysokość.
                            Główną rolę odgrywa tu wysokość i szerokość zdjęcia pobrana z parametrów (faktyczne wymiary zdjęcia ustalane wcześniej) oraz wartość przesunięcia zdjęcia, która jest w zmiennej parallaxObj.initialBackPosY i zapisywana do zmiennej parallaxObj.backOffsetY.

                            Wartość przesunięcia parallaxObj.backOffsetY wyznacza nam wysokość zdjęcia, ponieważ wysokość jest liczona jako 100% wysokości kontenera + to przesunięcie.

                            Jeżeli wysokość zdjęcia (container.offsetHeight + parallaxObj.backOffsetY, czyli wysokość kontenera i przesunięcie) spowoduje, że po bokach zabraknie zdjęcia na szerokość, to wtedy zmienna parallaxObj.backOffsetY jest przeliczana względem szerokości kontenera - w efekcie zdjęcie może być sztucznie powiększone, ale nie będzie wtedy żadnych przerw i dziur.
                        */
                        parallaxObj.backOffsetY = parallaxObj.initialBackPosY;
                        if (parallaxObj.backOffsetY < 0) parallaxObj.backOffsetY *= -1; //zmienna parallaxObj.initialBackPosY musi być dodatnia
                        let imgW = 0, imgH = 0;
                        if (parallaxObj.imagesize) {
                            imgW = parseInt(parallaxObj.imagesize.w);
                            imgH = parseInt(parallaxObj.imagesize.h);
                            if (imgW != "" && imgH != "" && imgW > 0 && imgH > 0 && Number.isInteger(imgW) && Number.isInteger(imgH)) {
                                let sectionWidth = Math.round(imgW * (container.offsetHeight + parallaxObj.backOffsetY) / imgH);
                                if (sectionWidth < container.offsetWidth) {
                                    parallaxObj.backOffsetY = Math.round(container.offsetWidth * (container.offsetHeight + parallaxObj.backOffsetY) / sectionWidth) - container.offsetHeight;
                                    if (parallaxObj.backOffsetY < 0) parallaxObj.backOffsetY *= -1;
                                }
                            }
                        }

                        /*
                            Na potrzeby mechanizmu IntersectionObserver do elementu kontenera dodajemy atrybut, którym jest numer wiersza w tablicy parallaxifyElemArray. Z pomocą przychodzi paramtr index, który takim numerem jest. Poźniej dzięki utworzonemu atrybutowi data-parallaxify-number będzie można w Observerze w odpowiednim wierszu tablicy ustawić zmienną odpowiadającą za to, czy dany element jest w widoku czy nie
                        */
                        container.dataset.parallaxifyNumber = index;

                        /*
                            Mamy wyliczone startowe przesunięcie zdjęcia oraz wysokość zdjęcia, która wynosi 100% wysokości kontenera + naddatek, który w czasie scrollowania zostanie odsłonięty.

                            Albo będzie ustawiony background-position dla container albo transform dla containerParallax
                        */
                        containerParallax.style.height = "calc(100% + " + String(parallaxObj.backOffsetY) + "px)";
                        containerParallax.style.transform = 'translateY(' + String(parallaxObj.initialBackPosY) + "px)";

                        //container.style.backgroundPosition = "center " + String(parallaxObj.initialBackPosY) + "px";
                        //container.style.backgroundSize = "auto calc(100% + " + String(parallaxObj.backOffsetY) + "px)";
                        break;
                }
            }
        });

        /*
            Nowość luty 2025 - wykorzystanie mechanizmu IntersectionObserver, który pozwala wykryć czy element jest w polu widzenia i dzięki temu nie trzeba przy każdym scrollu sprawdzać pozycji tego elementu od góry, co jest zasobo- i pamięciożerne. Jeżeli element jest w polu widzenia, to zmienna isInView będzie ustawiona na true, a jeżeli nie - to false.

            W ustawieniach poniżej parametr rootMargin działa jak margin w CSS i -50px oznacza tu, że dolna linia widoku jest wyżej niż dolna krawędź przeglądarki o 50px (tak jakbyśmy dawali info, że ekran jest o 50px niższy niż faktycznie). To jest nic innego niż baseline, przy czym ta wartość - o ile wcześniej dla każdego elementu mogła być inna, o tyle już Observer wymusza taki sam rootMargin dla wszystkich elementów, czyli baseline musi być wszędzie 50px w tym przypadku. Oczywiście na potrzeby przeliczenia przesunięcia tła baseline jest potem odpowiednio przeliczany, ale obie te wartości muszę być takie same (pomijając fakt, że tutaj w rootMargin jest to wartość ujemna, w baseline - dodatnia).
        */

        const parallaxifyObserverOptions = {
            root: null, // Obserwujemy względem całego widocznego obszaru przeglądarki
            rootMargin: '0px 0px -50px 0px', // marginesy wokół obszaru
            //threshold: 0.5 // Element będzie uznany za widoczny, gdy 50% będzie w polu widzenia
        };

        /*
            Tworzymy mechanizm IntersectionObserver
        */

        const parallaxifyObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // Jeśli element jest widoczny w polu widzenia, ustawiamy zmienną isInView w tablicy parallaxifyElemArray w wierszu entry.target.dataset.parallaxifyNumber
                    if (parallaxifyElemArray[entry.target.dataset.parallaxifyNumber]) parallaxifyElemArray[entry.target.dataset.parallaxifyNumber].isInView = true;
                } else {
                    // Jeśli element nie jest widoczny w polu widzenia, ustawiamy zmienną isInView w tablicy parallaxifyElemArray w wierszu entry.target.dataset.parallaxifyNumber
                    if (parallaxifyElemArray[entry.target.dataset.parallaxifyNumber]) parallaxifyElemArray[entry.target.dataset.parallaxifyNumber].isInView = false;
                }
            });
        }, parallaxifyObserverOptions);

        /*
            Ustawiamy mechanizm IntersectionObserver dla każdego elementu parallaxifyTargets
        */
        parallaxifyTargets.forEach(target => {
            parallaxifyObserver.observe(target);
        });
    }

    parallaxifyInit();

    function parallaxifyInView() {
        parallaxifyElemArray.forEach(function (parallaxObj, index) {
            let container = parallaxObj.container;
            let containerParallax = parallaxObj.containerParallax;
            if (container) {
                /*
                    Całe wyliczenie odnośnie warunku if (elementOffsetFromBottom > viewportScrollTop && elementOffsetFromTop < viewportScrollBottom) zostało usunięte, ponieważ to jest powielenie warunku if (container.getBoundingClientRect().top <= parallaxObj.baseline && Math.round(container.getBoundingClientRect().top) > (-1 * container.offsetHeight))
                */
                let opacityVal;
                let posX;
                let posY;

                switch (parallaxObj.property) {
                    case "background-position-y":
                        /*
                            Sprawdzamy czy kontener znajduje się w wyznaczonym obszarze:
                            - containerRectTop <= parallaxObj.baseline, czyli gdy górna krawędź kontenera idzie do góry i "mija" linię baseline
                            - containerRectTop > (-1 * container.offsetHeight), czyli dopóki górna krawędź kontenera będzie większa od swojej wysokości (pomnożonej przez -1), co oznacza, że jeżeli warunek ten nie jest spełniony, to dolna krawędź kontenera spotyka się z górną krawędzią okna przeglądarki (czyli kontener jest wówczas całkowicie ukryty)

                            Info: container.getBoundingClientRect().top potrafi być liczbą z ułamkami, np. 3.43543 dlatego zaokrąglamy ją. By nie powielać wszędzie tego zaokrąglenia, zapisujemy tę wartość do zmiennej containerRectTop

                            ZMIANA luty 2025
                            Dzięki mechanizmowi IntersectionObserver nie trzeba już przy każdym scrollu pobierać pozycji obiektu od góry ekranu, ponieważ to, czy ten obiekt jest w polu widzenia, jest określony w zmiennej isInView.

                            Rozwiązanie poprzednie:
                            let containerRectTop = Math.round(container.getBoundingClientRect().top);
                            if (containerRectTop <= parallaxObj.baseline && containerRectTop > (-1 * Math.round(container.offsetHeight))) {

                        */
                        if (parallaxObj.isInView) {
                            /*
                            Zmienna baseline jest ustawiana tylko i wyłącznie gdy nie jest jeszcze ustawiona (co zdarzyć się nie powinno)
                            */
                            if (!parallaxObj.baseline) parallaxObj.baseline = window.innerHeight - 50;



                            /*
                                Wiemy już, że górna krawędź kontenera jest już powyżej baseline (bo powyższy warunek if to zweryfikował), w związku z tym obliczamy jaka jest różnica odleglości pomiędzy baseline a tą krawędzią i zapisujemy ją do zmiennej parallaxObj.backPosY, a następnie pomniejszamy ją według takiego samego obliczenia jakie miało miejsce na samym starcie, przy czym zmienna speed została już obliczona i zapisana do zmiennej parallaxObj.speed.
                            */
                            parallaxObj.backPosY = Math.round(parallaxObj.baseline - Math.round(container.getBoundingClientRect().top));

                            /*
                                Nie zapominamy o startowym, obliczonym wcześniej, przesunięciu tła, które znajduje się w zmiennej parallaxObj.initialBackPosY. Dodajemy do tej wartości obliczone przesunięcie bieżące parallaxObj.backPosY
                            */
                            if (!parallaxObj.initialBackPosY && parallaxObj.initialBackPosY != 0) parallaxObj.initialBackPosY = 200;
                            parallaxObj.backPosY = Math.round(parallaxObj.initialBackPosY + parallaxObj.backPosY / parallaxObj.speed);

                            /*
                                Gotowe wyliczenia wstawiamy do kontenera
                                Albo będzie ustawiony background-position dla container albo transform dla containerParallax
                            */
                            containerParallax.style.height = "calc(100% + " + String(parallaxObj.backOffsetY) + "px)";
                            containerParallax.style.transform = 'translateY(' + String(parallaxObj.backPosY) + "px)";

                            //container.style.backgroundPosition = "center " + String(parallaxObj.backPosY) + "px";
                            //container.style.backgroundSize = "auto calc(100% + " + String(parallaxObj.backOffsetY) + "px)";
                        }
                        break;
                    case "background-position-x":
                        posX = Math.round((window.scrollY - elementOffsetFromTop) / parallaxObj.speed);
                        container.setAttribute("style", "background-position:  " + posX + "px center;");
                        break;
                    case "opacity-out":
                        if (parallaxObj.target) {
                            if (!parallaxObj.offset) parallaxObj.offset = 0;
                            posY = container.getBoundingClientRect().top + parallaxObj.offset;
                            opacityVal = 1 + (posY / 1000) * 1;
                            parallaxObj.target.style.opacity = opacityVal;
                        }
                        break;
                    case "opacity-in":
                        if (parallaxObj.target) {
                            if (!parallaxObj.offset) parallaxObj.offset = 0;
                            posY = container.getBoundingClientRect().top + parallaxObj.offset;
                            opacityVal = 1 - (posY / 1000) * 1;
                            parallaxObj.target.style.opacity = opacityVal;
                        }
                        break;
                    case "move-x-left":
                        if (parallaxObj.target) {
                            parallaxObj.speed = (parallaxObj.speed >= 100) ? 99 : parallaxObj.speed;
                            let speed = 50 - parallaxObj.speed;
                            speed = 50 + speed;
                            speed = (speed < 0) ? 0 : speed;
                            if (!parallaxObj.offset) parallaxObj.offset = 0;
                            posX = container.getBoundingClientRect().top + parallaxObj.offset;
                            posX = Math.round(posX / speed);
                            parallaxObj.target.style.transform = "translateX(" + posX + "px)";
                        }
                        break;
                    case "move-y-up-down":
                        if (parallaxObj.target) {
                            let speed = parallaxObj.speed - 100;
                            speed = (speed < 0) ? (-1 * speed) / 10 : speed / 10;
                            if (!parallaxObj.offset) parallaxObj.offset = 0;
                            posY = container.getBoundingClientRect().top + parallaxObj.offset;
                            posY = Math.round((posY * -1) / speed);

                            parallaxObj.target.style.transform = "translateY(" + posY + "px)";

                            if (parallaxObj.opacityOut) {
                                opacityVal = 1 + ((container.getBoundingClientRect().top + parallaxObj.offset) / 1000) * 1;
                                parallaxObj.target.style.opacity = opacityVal;
                            }
                        }
                        break;
                    case "move-y-up-down-hero":
                        if (parallaxObj.target) {
                            let speed = parallaxObj.speed - 100;
                            speed = (speed < 0) ? (-1 * speed) / 10 : speed / 10;
                            if (!parallaxObj.offset) parallaxObj.offset = 0;
                            //gdy hero section nie zaczyna się od samiutkiej góry ekranu (tylko np jest pod nagłówkiem), to trzeba odjąć odstęp między hero a górną krawędzią okna
                            //wyliczamy to w poniższej zmiennej i dodajemy wartość do posY
                            //bez tej wartości jeżeli napis na środku hero jest parallaxowany, to on na początku dostanie już jakąś wartość ujemną (a zatem będzie przesunięty w górę)
                            //a my chcemy żeby miał on początkową wartość przesunięcia równą 0 - tak by było gdyby hero było od samej góry i użylibyśmy opcji "move-y-up-down"
                            let offsetElemFromTop = -1 * (container.getBoundingClientRect().top + window.scrollY);
                            posY = container.getBoundingClientRect().top + offsetElemFromTop;
                            posY = Math.round((posY * -1) / speed);
                            parallaxObj.target.style.transform = "translateY(" + posY + "px)";

                            if (parallaxObj.opacityOut) {
                                opacityVal = 1 + ((container.getBoundingClientRect().top + parallaxObj.offset) / 5000) * 1;
                                if (opacityVal > 1) opacityVal = 1;
                                parallaxObj.target.style.opacity = opacityVal;
                            }
                        }
                        break;
                    case "move-y-down-fromtop":
                        if (parallaxObj.target) {
                            //jeżeli odległość kontenera paralaksu od górnej krawędzi będzie mniejsza od linii bazowej oraz jeżeli będzie większa od -500
                            //to animacja wykonuje się
                            //-500 to liczba umowna, można dać wysokość elementu by animacja nie zakończyła się gdy górna krawędź elementu dotknie górnej krawędzi okna
                            if (container.getBoundingClientRect().top > -500) {
                                //różnica pomiędzy linią bazową a odległością pomiędzy górną krawędzią kontenera paralaksu od górnej krawędzi okna
                                //jeżeli, np. baseLine = 800, a container.getBoundingClientRect().top - 700 to parallaxObj.posY = 100 i o tyle przesuwamy nasz target
                                parallaxObj.posY = window.scrollY;
                                //oczywiście żeby to głupio nie wyglądało to przykładową wartość 100 musimy zmniejszyć
                                //dlaczego jest 100 - parallaxObj.speed? Bo parallaxObj.speed to parametr - liczba od 0 do 100: chcemy żeby zwiększenie tej liczby zwiększło prędkość przesuwania
                                //jednak im większa liczba tym to przesunięcie będzie wolniejsze, więc żeby to było logicznie od odejmujemy liczbę od 100
                                let speed = 100 - parallaxObj.speed;
                                if (speed < 0 || speed > 100) speed = 10;
                                parallaxObj.posY = parallaxObj.posY / speed;
                                if (parallaxObj.posY < 0) parallaxObj.posY = 0; //element nie przesunie się wyżej niż jego pozycja bazowa
                            }
                            if (parallaxObj.posY) parallaxObj.target.setAttribute("style", "transform: translateY(" + Math.round(parallaxObj.posY) + "px)");
                        }
                        break;
                    case "move-y-down":
                        if (parallaxObj.target) {
                            if (!parallaxObj.baseline) parallaxObj.baseline = 200;
                            let baseLine = window.innerHeight - parallaxObj.baseline; //domyślnie 200px od dolnej krawędzi okna
                            //jeżeli odległość kontenera paralaksu od górnej krawędzi będzie mniejsza od linii bazowej oraz jeżeli będzie większa od -500
                            //to animacja wykonuje się
                            //-500 to liczba umowna, można dać wysokość elementu by animacja nie zakończyła się gdy górna krawędź elementu dotknie górnej krawędzi okna
                            if (container.getBoundingClientRect().top <= baseLine && container.getBoundingClientRect().top > -500) {
                                //różnica pomiędzy linią bazową a odległością pomiędzy górną krawędzią kontenera paralaksu od górnej krawędzi okna
                                //jeżeli, np. baseLine = 800, a container.getBoundingClientRect().top - 700 to parallaxObj.posY = 100 i o tyle przesuwamy nasz target
                                parallaxObj.posY = baseLine - container.getBoundingClientRect().top;
                                //oczywiście żeby to głupio nie wyglądało to przykładową wartość 100 musimy zmniejszyć
                                //dlaczego jest 100 - parallaxObj.speed? Bo parallaxObj.speed to parametr - liczba od 0 do 100: chcemy żeby zwiększenie tej liczby zwiększło prędkość przesuwania
                                //jednak im większa liczba tym to przesunięcie będzie wolniejsze, więc żeby to było logicznie od odejmujemy liczbę od 100
                                let speed = 100 - parallaxObj.speed;
                                if (speed < 0 || speed > 100) speed = 10;
                                parallaxObj.posY = parallaxObj.posY / speed;
                                if (parallaxObj.posY < 0) parallaxObj.posY = 0; //element nie przesunie się wyżej niż jego pozycja bazowa
                            }
                            if (parallaxObj.posY) parallaxObj.target.setAttribute("style", "transform: translateY(" + Math.round(parallaxObj.posY) + "px)");
                        }
                        break;
                    case "move-y-up":
                        if (parallaxObj.target) {
                            if (!parallaxObj.baseline) parallaxObj.baseline = 200;
                            let baseLine = window.innerHeight - 200;
                            if (container.getBoundingClientRect().top <= baseLine && container.getBoundingClientRect().top > -500) {
                                parallaxObj.posY = baseLine - container.getBoundingClientRect().top;
                                let speed = 100 - parallaxObj.speed;
                                if (speed < 0 || speed > 100) speed = 10;
                                parallaxObj.posY = parallaxObj.posY / speed;
                                if (parallaxObj.posY > 0) parallaxObj.posY *= -1;
                            }
                            if (parallaxObj.posY) parallaxObj.target.setAttribute("style", "transform: translateY(" + Math.round(parallaxObj.posY) + "px)");
                        }
                        break;
                }
            }
        });
    }

    /*for (event of ["scroll"]) {
        window.addEventListener(event, function () {
            window.requestAnimationFrame(parallaxifyInView);
        });
    }*/

    let isTicking = false;
    window.addEventListener("scroll", function () {
        if (!isTicking) {
            window.requestAnimationFrame(function () {
                parallaxifyInView();
                isTicking = false;
            });
            isTicking = true;
        }
    }, { passive: true });

    var parallaxifyWindowWidth = window.innerWidth;
    for (event of ["resize", "orientationchange"]) {
        /*
            Tutaj uwaga!
            Resize może się wywołać w sposób nieoczekiwany, gdy na telefonie podczas scrollowania strony znika pasek URL w przeglądarce (Chrome). Wówczas dochodzi do zmiany wysokości okna i zdarzenie resize wykonuje się, co z kolei powoduje powstawanie anomalii, ponieważ w trakcie scrollowania na nowo zostaje przeliczone startowe przesunięcie tła i zdjęcie zaczyna skakać, ponieważ startowe przesunięcie nadpisuje bieżące przesunięcie tła. Dlatego zostało tutaj dodane zabezpieczenie, że resize będzie tylko działał dla zmiany szerokości okna, a nie wysokości.
        */
        window.addEventListener(event, function () {
            var width = window.innerWidth;
            if (parseInt(width) != parseInt(parallaxifyWindowWidth)) {
                parallaxifyWindowWidth = width;
                parallaxifyElemArray = [];
                parallaxifyInit();
            }
        });
    }

    const parallaxifyTimeOut = setTimeout(function () {
        parallaxifyInView();
    }, 500);
});